import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
export default store => ({
  path: ":documentid",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "document-editor" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentDetails(store)],
});
